import React from 'react';
import Icon1 from '../../images/Services Com.png';
import Icon1v1 from '../../images/Under Construction.png';
import Icon2 from '../../images/Services Strategic.png';
import Icon2v1 from '../../images/Services Strategic Modal.png';
import Icon3 from '../../images/Services Updates.png';
import Icon3v1 from '../../images/Services Updates ModalV1.png';
import Icon4 from '../../images/Services Paid.png';
import Icon4v1 from '../../images/Services Paid Modal.png';
import Wait from '../../images/Wait.png';
import Certs from '../../images/Certs.png';
import Old from '../../images/Old Website V2.png';
import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesCardCert,
  ServicesCardWait,
  ServicesIcon,
  ServicesH2,
  ServicesP,
  ModalContainer,
  ServiceButton,
  Img,
  ModalP,
  ModalIcon,
  ModalButton,
  ModalWrapper,
  ModalH,
  WaitIcon,
} from './ServicesElements';


import ReactDOM from 'react-dom';
import Modal from 'react-modal';
 

const Services = () => {
  let subtitle;
//Modal Bool Statements 
const [MarkmodalIsOpen, setMarkIsOpen] = React.useState(false);
const [CommodalIsOpen, setComIsOpen] = React.useState(false);
const [PaidmodalIsOpen, setPaidIsOpen] = React.useState(false);
const [UpdatemodalIsOpen, setUpdateIsOpen] = React.useState(false);

function ALLafterOpenModal() {
  // references are now sync'd and can be accessed.
  //subtitle.style.color = '#262626';
 // background.style.color = '#262626';
}
const customStyles = {
  content: {
    top: '500px',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',

   
    transform: 'translate(-50%, -50%)',
    maxWidth: '80%', // Limit maximum width
    maxHeight: '80vh', // Limit maximum height to 80% of the viewport height
    overflow: 'auto', // Allow scrolling if content exceeds modal dimensions
   
  },
};



function openMarkModal() {
  setMarkIsOpen(true);
}

function closeMarkModal() {
  setMarkIsOpen(false);
}

function openComModal() {
  setComIsOpen(true);
}

function closeComModal() {
  setComIsOpen(false);
}

function openPaidModal() {
  setPaidIsOpen(true);
}

function closePaidModal() {
  setPaidIsOpen(false);
}

function openUpdateModal() {
  setUpdateIsOpen(true);
}

function closeUpdateModal() {
  setUpdateIsOpen(false);
}

  return (
    <ServicesContainer id='services'>
      <ServicesH1>Projects & Certifactions</ServicesH1>
     
    {/* START Com button modal Section */}
      <ServicesWrapper>
        <ServicesCard onClick={openComModal}>
          <ServicesIcon src={Icon1v1} />
          <ServicesH2>Old Profolio Website</ServicesH2>
        </ServicesCard>

        <Modal
        isOpen={CommodalIsOpen}
        onAfterOpen={ALLafterOpenModal}
        onRequestClose={closeComModal}
        style={customStyles}
        contentLabel="Example Modal"
        
      >
<ModalContainer>
  <ModalH>Old Website - www.kobecox.com</ModalH>
<ModalWrapper>
  <ModalP>
 This is my old portfolio website


  </ModalP>
  <ModalIcon src={Icon1v1} />
  </ModalWrapper>

<ModalButton onClick={closeComModal}>Close</ModalButton>
</ModalContainer>
      </Modal>

        {/*  Com button modal Section END*/}

        {/* START Paid Promotion button modal Section */}
      <ServicesCardWait onClick={openPaidModal}>
          <WaitIcon src={Wait} />
          <ServicesH2>Wait. </ServicesH2>
          
        </ServicesCardWait>
        <Modal
        isOpen={PaidmodalIsOpen}
        onAfterOpen={ALLafterOpenModal}
        onRequestClose={closePaidModal}
        style={customStyles}
        contentLabel="Example Modal"
        
      >
<ModalContainer>
  <ModalH>Wait. - College Project</ModalH>
<ModalWrapper>
  <ModalP>
This is a App I developed in my last year of college



  </ModalP>
  <ModalIcon src={Icon1v1} />
  </ModalWrapper>

<ModalButton onClick={closePaidModal}>Close</ModalButton>
</ModalContainer>
      </Modal>
        {/* END Paid Promotion button modal Section */}
{/* START Update button modal Section */}
        <ServicesCardCert onClick={openUpdateModal}>
          
          <ServicesIcon src={Certs} />
          <ServicesH2>Certifactions</ServicesH2>
         
        </ServicesCardCert>
        <Modal
        isOpen={UpdatemodalIsOpen}
        onAfterOpen={ALLafterOpenModal}
        onRequestClose={closeUpdateModal}
        style={customStyles}
        contentLabel="Example Modal"
        
      >
<ModalContainer>
  <ModalH>Security Certifactions</ModalH>
<ModalWrapper>
  <ModalP>
  I have 3 certifcates reading information security.


  </ModalP>
  <ModalIcon src={Icon1v1} />
  </ModalWrapper>

<ModalButton onClick={closeUpdateModal}>Close</ModalButton>
</ModalContainer>
      </Modal>
        {/* END Update button modal Section */}
      </ServicesWrapper>


      
    </ServicesContainer>
  );
};

export default Services;
